export { default as KpiComplianceProgressivePanel } from "./KpiComplianceProgressivePanel.vue";
